import React from 'react';
import { CFBaseFieldUtils, } from '@connectrn/ds-ui-base';
import { CFIconBadge } from '../../../components';
export const FieldValidationBadge = ({ disabled = false, fieldSize = 'md', showValidationBadge = true, validationState = 'default', }) => {
    if (!showValidationBadge || disabled || validationState === 'default')
        return null;
    const iconBadgeConfigs = CFBaseFieldUtils.getValidationBadge({
        fieldSize,
        validationState,
    });
    return iconBadgeConfigs ? React.createElement(CFIconBadge, Object.assign({}, iconBadgeConfigs)) : null;
};
